
<h1 mat-dialog-title><b>{{TituloErro}}</b></h1>
<hr>
<div mat-dialog-content [ngClass]="{ 'text-danger': MensagemErroCor === 'Vermelho' }" [innerHTML]="MensagemErro"></div>
<div mat-dialog-actions class="botao">
  <button mat-flat-button [color]="BotaoCor" mat-dialog-close="cancel" style="margin-left: auto;">{{BotaoMesagem}}</button>
</div>

